import { date } from 'quasar'
import { useUserStore } from 'stores/receiver/account/user/user'
import type { IntercomUserData } from 'composables/common/intercom/useIntercom'

export const useReceiverIntercom = () => {
  const getUserData = () => {
    const userStore = useUserStore()
    const { formatDate } = date

    const userData = {} as IntercomUserData
    if (userStore.isLoggedIn && userStore.user) {
      userData.user_hash = userStore.user.intercom_id_verification
      userData.email = userStore.user.email
      userData.user_id = userStore.user.id
      if (userStore.user.profile.firstname && userStore.user.profile.lastname) {
        userData.name = `${userStore.user.profile.firstname} ${userStore.user.profile.lastname}`
      } else {
        userData.name = userStore.user.email.split('@')[0]
      }
      userData.created_at = parseInt(formatDate(userStore.user.created_at, 'X'))
      userData.unsubscribed_from_emails = false
      userData.language_override = userStore.user.preferences.language
      if (userStore.activeOrganisation)
        userData.company = {
          name: userStore.activeOrganisation.name,
          id: userStore.activeOrganisation.organisation_id,
          number_of_templates: userStore.activeOrganisation.number_of_templates,
        }
      userData.companies = userStore.organisations.map((org) => {
        const company = {
          name: org.name,
          id: org.organisation_id,
        } as NonNullable<IntercomUserData['company']>
        if (org.active) {
          company.number_of_templates = org.number_of_templates
        }
        return company
      })
      if (userStore.user.profile.firstname)
        userData.first_name = userStore.user.profile.firstname
      if (userStore.user.profile.lastname)
        userData.last_name = userStore.user.profile.lastname
      if (userStore.user.profile.job)
        userData.job_title = userStore.user.profile.job

      return userData
    }
  }
  return { getUserData }
}
